export default {
  loading: false,
  templates: [],
  template: {},
  pagination: {},
  messageResource: false
}